import { createSlice } from "@reduxjs/toolkit/"

let initialState = {
    reponsesList : [],
    selectedReponse:{},
}
const reponsesSlice = createSlice({
    name:'reponses',
    initialState,
    reducers:{
        setReponsesList:(state,{payload})=>{
            state.reponsesList = payload
        },
        setSelectedReponse:(state,{payload})=>{
            state.selectedReponse = payload
        },
    }
})

export const { setReponsesList,setSelectedReponse } = reponsesSlice.actions
export default reponsesSlice.reducer